export default __webpack_public_path__ + "static/media/bulb.d42478fd.svg";